import {
  NetworkEventData,
  RCEvent,
  EventName,
  EventType,
} from "../../core/eventhub/eventmodels.js";
import { EventController } from "../../core/eventhub/eventcontroller.js";
import { RidecellCallback } from "../../core/models/ridecellcallback.js";
import { CarsharingNetworkRequests } from "../networkrequestsbuilder.js";

export class TripActivityController {
  /**
   * Gets past/upcoming rental trips by adding event to EventHub.
   * Processes the response before returning to caller.
   *
   * @param {number} pageNumber Start page number.
   * @param {number} pageSize Page size for number of trips to return.
   * @param {boolean} isPast Boolean to indicate if it is a past or upcoming trip.
   * @param {boolean} includeCancelled Boolean to indicate if cancelled trips should be included.
   *
   * @returns {Object} response Response with the past trips data.
   * @returns {number} response.totalCount Total number of upcoming trips that can be retrieved.
   */
  getTrips(params) {
    return new Promise((resolve, reject) => {
      const queryParams = {
        role: "CUSTOMER",
        ...params,
      };
      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.tripactivities,
        queryParams //queryData
      );

      const getTripsCallback = new RidecellCallback();
      getTripsCallback.onSuccess = (response) => {
        resolve(response.results);
      };

      getTripsCallback.onFailure = (error) => {
        reject(error);
      };
      this.sendEvent(
        new RCEvent(EventName.NETWORK, requestData, getTripsCallback)
      );
    });
  }

  sendEvent(event) {
    EventController.addEvent(event);
  }
}
